import React from 'react'
import {useSelector} from 'react-redux'
import {cx} from '@emotion/css'
import {CompactFooter} from 'components/CompactFooter'
import CookieBanner from 'components/CookieBanner'
import {MobileOverlays} from 'components/MobileOverlays/MobileOverlays'
import {Web2AppHoldOutWrapper} from 'components/Web2AppHoldOutWrapper'
import {TopBannerProvider} from 'contexts/TopBannerContext'
import {getUserAgentDetails} from 'modules/meta/selectors'

import OpacityAnimation from '@vio/atlas/helpers/OpacityAnimation'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {Page} from '@vio/core/src/analytics/types/Events'
import {isFlutterAppWebView} from '@vio/core/src/native'
import {useIsHydrated} from '@vio/core/src/utils/react/hooks/useIsHydrated'

import {MobileHeader} from '../MobileHeader'
import {MobileTopAppBanner} from '../MobileTopAppBanner'
import {
  FooterWrapper,
  HeaderSpacer,
  HeaderWrapper,
  LayoutWrapper,
  MainContentWrapper
} from './mobileStyles'

interface PropsType {
  hasHeaderSearchSummary?: boolean
  hasHeaderDivider?: boolean
  hasSearchForm?: boolean
  hasHeader?: boolean
  hasHeaderMenu?: boolean
  hasFooter?: boolean
  hasBackButton?: boolean
  headerTitle?: React.ReactElement
  hasSearchProgressBar?: boolean
  page?: Page
}

export const MobileBaseLayout: React.FC<React.PropsWithChildren<PropsType>> = ({
  children,
  hasHeaderSearchSummary = true,
  hasHeaderDivider = false,
  hasSearchForm = false,
  hasHeader = true,
  hasHeaderMenu = true,
  hasFooter = true,
  hasSearchProgressBar = false,
  hasBackButton,
  headerTitle,
  page
}) => {
  const isSafari = useSelector(getUserAgentDetails)?.isSafari // userAgentDetails is unknown during SSR
  const mobileHeaderIsFixed = hasSearchForm
  const {retention} = useBrandCapabilities()
  const isWebView = isFlutterAppWebView()
  const isHydrated = useIsHydrated()

  return (
    <TopBannerProvider>
      <LayoutWrapper>
        {isHydrated && <CookieBanner />}

        {hasHeader && (
          <HeaderWrapper className={cx(mobileHeaderIsFixed && '--is-fixed')}>
            <Web2AppHoldOutWrapper
              element={<MobileTopAppBanner />}
              enabled={!isWebView && retention.hasWeb2App}
              holdOutElement={null}
            />
            <MobileHeader
              hasDivider={hasHeaderDivider}
              hasHeaderSearchSummary={hasHeaderSearchSummary}
              hasHeaderBottomContent={hasSearchForm}
              hasHeaderMenu={hasHeaderMenu}
              hasSearchProgressBar={hasSearchProgressBar}
              hasBackButton={hasBackButton}
              headerTitle={headerTitle}
              page={page}
            />
          </HeaderWrapper>
        )}
        {mobileHeaderIsFixed && <HeaderSpacer />}
        {!hasHeader && (
          <Web2AppHoldOutWrapper
            element={<MobileTopAppBanner />}
            enabled={!isWebView && retention.hasWeb2App}
            holdOutElement={null}
          />
        )}
        <MainContentWrapper>{children}</MainContentWrapper>
        {hasFooter && (
          <FooterWrapper isSafari={isSafari}>
            <OpacityAnimation delay={500}>
              <CompactFooter />
            </OpacityAnimation>
          </FooterWrapper>
        )}
      </LayoutWrapper>
      <MobileOverlays />
    </TopBannerProvider>
  )
}
